import React from 'react';
import Tooltip from 'react-tooltip';
import { useStyles } from './styles';
const BaseTooltip = ({ children, id }) => {
    const ownClasses = useStyles();
    return (React.createElement(Tooltip, { className: ownClasses.root, id: id, place: "top", effect: "solid" }, children));
};
export default BaseTooltip;
